import React from 'react';

import Grid from '@mui/material/Grid2';

import { CraftingMaterial } from "@dndModels";

interface Props {
  materials: CraftingMaterial[];
}

const round = (n: number) => Math.round(n * 100) / 100;

// Shows the crafting materials in an inventory. These are kept separate from items.
export default function CraftingMaterialsList({ materials }: Props) {
  const sorted = [...materials].sort((a, b) => a.material_type === b.material_type ?
    a.name.localeCompare(b.name) : a.material_type.localeCompare(b.material_type));
  return (
    <Grid size={12} className="padded">
      <Grid container spacing={0} direction="row">
        <Grid size={12} className="header">
          Crafting Materials
        </Grid>
        { sorted.length === 0 ?
          <Grid size={12} className="gray">None</Grid>
        :
          <>
            <Grid size={5}><b>Material</b></Grid>
            <Grid size={1} className="centered"><b>Amount</b></Grid>
            <Grid size={3} className="centered"><b>Weight</b></Grid>
            <Grid size={3} className="centered"><b>Value</b></Grid>
            { sorted.map(material => (
              <React.Fragment key={material.true_id}>
                <Grid size={5}>
                  <div>{ material.material_type }</div>
                  <div className="small_label gray">{ material.source_string }</div>
                </Grid>
                <Grid size={1} className="centered">{ material.amount }</Grid>
                <Grid size={3} className="centered">
                  { round(material.total_weight) } lb <span className="small_label gray">({ material.weight } each)</span>
                </Grid>
                <Grid size={3} className="centered">
                  { round(material.total_value) } gp <span className="small_label gray">({ material.value } each)</span>
                </Grid>
              </React.Fragment>
            ))}
            <Grid size={6}><b>Total</b></Grid>
            <Grid size={3} className="centered">
              <b>{ round(sorted.reduce((sum, o) => sum + o.total_weight, 0)) } lb</b>
            </Grid>
            <Grid size={3} className="centered">
              <b>{ round(sorted.reduce((sum, o) => sum + o.total_value, 0)) } gp</b>
            </Grid>
          </>
        }
      </Grid>
    </Grid>
  );
}
